import React from "react";

import ImageCard from "../ImageCard";

import type { CardBlogProps } from "./cardBlog.types";
import type {
  ImageCardCustomStyles,
  ImageCardImageProps
} from "../ImageCard/imageCard.types";

import s from "./cardBlog.module.scss";

const CardBlog = ({ title, description, image, link, slug }: CardBlogProps) => {
  const linkProps = {
    link: `${link}?utm_source=site&utm_medium=card-racas&utm_campaign=${slug}`,
    outsideLink: true
  };

  const imageProps: ImageCardImageProps = {
    src: image,
    alt: `imagem de ${title}`
  };

  const customStyles: ImageCardCustomStyles = {
    root: {
      borderRadius: "var(--token-border-radius-md)",
      width: "24rem"
    },
    image: {
      width: "100%",
      height: "160px",
      objectFit: "cover"
    }
  };

  return (
    <ImageCard
      linkProps={linkProps}
      imageProps={imageProps}
      hasHover={false}
      customStyles={customStyles}
    >
      <div className={s.card_content}>
        <h3 className={`subtitle-md ${s.card_title}`}>{title}</h3>
        <p
          className={`body-text-sm ${s.card_description}`}
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <div className="link link-turquoise" data-testid={`link-${slug}`}>
          Ler mais
        </div>
      </div>
    </ImageCard>
  );
};

export default CardBlog;
